const WEEKDAYS = {
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',
  sunday: 'Sunday'
}

const isMonday = day => day.toLowerCase() === WEEKDAYS.monday.toLowerCase()
const isTuesday = day => day.toLowerCase() === WEEKDAYS.tuesday.toLowerCase()
const isWednesday = day =>
  day.toLowerCase() === WEEKDAYS.wednesday.toLowerCase()
const isThursday = day => day.toLowerCase() === WEEKDAYS.thursday.toLowerCase()
const isFriday = day => day.toLowerCase() === WEEKDAYS.friday.toLowerCase()
const isSaturday = day => day.toLowerCase() === WEEKDAYS.saturday.toLowerCase()
const isSunday = day => day.toLowerCase() === WEEKDAYS.sunday.toLowerCase()

const WEEKDAYS_LIST = Object.keys(WEEKDAYS)

export {
  WEEKDAYS,
  WEEKDAYS_LIST,
  isMonday,
  isTuesday,
  isWednesday,
  isThursday,
  isFriday,
  isSaturday,
  isSunday
}
